import React, {Component} from 'react';
import PropTypes from 'prop-types';
import styled from "styled-components";

import {MAIN_APP} from '../MidiPlay.jsx';
import Colors from '../resource/ResourceColors.jsx';

const MAX_STEMS = 500;
const FRAME_WIDTH_PX = 500;

const ToneWalkerFrame = styled.div`
    display: inline-block;
    width: ${FRAME_WIDTH_PX}px;
    height: 98%;
    border-radius: 0.25rem;
    z-index: 100;
    border: 0.125rem solid ${Colors.grey(30)};
    filter: ${Colors.medium_shadow(50)};  
    box-shadow: inset ${Colors.medium_shadow(20)};
    background: ${Colors.right_diagonal_gradient_grey(60, 30)};  
`;

const CanvasHolder = styled.div`
    width: ${FRAME_WIDTH_PX}px;
    height: 100%;
`;

export class ModuleToneWalker extends Component {

    static propTypes = {
        client_data: PropTypes.object
    }

    state = {
        canvas_ref: React.createRef(),
        holder_ref: React.createRef(),
        ctx: null,
        gradient: null,
        height: 10
    };

    init_canvas() {
        const canvas = this.state.canvas_ref.current;
        if (!canvas) {
            console.log('no canvas');
            return null;
        }
        const holder = this.state.holder_ref.current;
        if (!holder) {
            console.log('no holder');
            return null;
        }
        const bounds = holder.getBoundingClientRect();
        const height = 1 + Math.floor(bounds.height);

        const ctx = canvas.getContext('2d');
        const gradient = ctx.createRadialGradient(100, 100, 5, FRAME_WIDTH_PX, height, 900);
        gradient.addColorStop(0, '#888888');
        gradient.addColorStop(1, '#222222');
        ctx.fillStyle = gradient;
        this.setState({
            ctx: ctx,
            gradient: gradient,
            height: height,
        });
        return ctx;
    }

    shift_canvas(ctx, w, h, dx, dy) {
        var imageData = ctx.getImageData(0, 0, w, h);
        ctx.clearRect(0, 0, w, h);
        ctx.putImageData(imageData, dx, dy);
    }

    render_canvas(most_recent) {
        const ctx = this.state.ctx ? this.state.ctx : this.init_canvas();
        if (!ctx) {
            return '';
        }

        const rightmost_offset = 3;
        const x = most_recent.length - rightmost_offset;
        if (x < 0) {
            return '';
        }
        let y = this.state.height - 1;
        most_recent[most_recent.length - 1].forEach((part, stem_key) => {
            ctx.fillStyle = part.hsl_str;
            const height = Math.floor(this.state.height * part.portion);
            ctx.fillRect(x, y - height, 1, height);
            y -= height;
        });
        if (most_recent.length === MAX_STEMS) {
            this.shift_canvas(ctx, FRAME_WIDTH_PX, this.state.height, -1, 0);
        }
    }

    render() {
        const default_response = <ToneWalkerFrame/>
        const playback = MAIN_APP.state.playback;
        if (!playback) {
            return default_response;
        }
        const all_profiles = playback.all_profiles;
        if (!all_profiles) {
            return default_response;
        }

        const most_recent = all_profiles.slice(-MAX_STEMS);
        this.render_canvas(most_recent);
        const canvas_style = {borderRadius: '0.25rem'};
        return <ToneWalkerFrame>
            <CanvasHolder ref={this.state.holder_ref}>
                <canvas
                    ref={this.state.canvas_ref}
                    width={(1 + FRAME_WIDTH_PX) + 'px'}
                    height={this.state.height + 'px'}
                    style={canvas_style}/>
            </CanvasHolder>
        </ToneWalkerFrame>;
    }
}

export default ModuleToneWalker;
